var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"van-radio"},[(_vm.isChecked)?_c('img',{staticClass:"active-icon",attrs:{"src":_vm.activeIcon}}):_c('i',{staticClass:"inactive-icon"})])}
var staticRenderFns = []
export { render, staticRenderFns }